<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pp_code,pp_vendname,pp_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.pp_id"
        :to="'/money/payapply/'+item.pp_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pp_vendname}}</p>
          <p class="list-item-muted">{{item.pp_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.pp_amount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pp_status!='已审核'}"
          >{{item.pp_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pp_amount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/money/payplease/list",
      filters: [
        {
          type: "date",
          name: "pp_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待付款",
              condition: "pp_statuscode <> 'AUDITED'"
            },
            {
              value: 2,
              label: "已付款",
              condition: "pp_statuscode='AUDITED' and abs(pp_amount)=abs(ifnull(pp_payamount,0))"
            },
            {
              value: 3,
              label: "背书转让",
              condition: " pp_statuscode='AUDITED' and abs(pp_amount)>abs(ifnull(pp_payamount,0))"
            },
          ]
        }
      ]
    };
  }
};
</script>